import { create } from "zustand";
import { MarkerAPI } from "../api";
import { InvestorMarker, Marker } from "../api/transformers/marker";

type InvestorMarkersStore = {
  data: InvestorMarker[] | null;
  loading: boolean;
  error: unknown;
  fetchData: (personId: string, markers: Marker[]) => void;
}

const useInvestorMarkerStore = create<InvestorMarkersStore>((set) => ({
  data: null,
  loading: true,
  error: null,
  // actions
  fetchData: async (personId, markers) => {
    set({ loading: true, error: null, data: null });
    try {
      const result = await MarkerAPI.getMarkersOfInvestor(personId, markers);
      set({ data: result, loading: false });
    } catch (err) {
      console.error(err);
      set({ error: err, loading: false });
    }
  }
}));

export default useInvestorMarkerStore;
